import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IMAGE_SRC } from '../../../shared-constants';

@Component({
  selector: 'app-table-time-picker',
  templateUrl: './table-time-picker.component.html',
  styleUrls: ['./table-time-picker.component.scss'],
  standalone: false,
})
export class TableTimePickerComponent implements OnInit {
  @Input() placeholder!: string;
  @Input() columnText!: string;
  @Input() resetData!: BehaviorSubject<boolean>;
  @Input() icon = IMAGE_SRC.CLOCK;
  @Input() hasAltBackground = false;

  @Output() emitChange = new EventEmitter();
  readonly IMAGES = IMAGE_SRC;

  destroy = inject(DestroyRef);
  timeFormat = 24;
  timeForm!: FormGroup;

  constructor(
    public readonly commonUtils: CommonUtils,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.timeForm = this.fb.group({
      time: [''],
    });

    this.resetData
      .asObservable()
      .pipe(
        takeUntilDestroyed(this.destroy),
        filter((value: boolean) => value),
      )
      .subscribe(() => {
        this.timeForm.get('time')?.reset();
      });
  }

  onModelChange(e: Event) {
    this.emitChange.emit(e?.toString());
  }

  fixTimeFormat() {
    let formValue = this.timeForm.get('time');
    let inputValue = formValue?.value?.replace(/\D/g, '');

    if (inputValue.length > 4) {
      inputValue = inputValue.substring(0, 4);
    }

    if (inputValue.length >= 3) {
      inputValue = inputValue.substring(0, 2) + ':' + inputValue.substring(2);
    }

    formValue?.setValue(inputValue);
  }
}
